import { PublicContentPage, publicPageHeading } from '../../features/public/PublicContentPage';
import { PublicCta } from '../../features/public/PublicCta';
import { seoForPath } from '../../features/public/seoConfig';

const STEPS = [
  {
    step: '1',
    title: 'Sign in with Google',
    body: 'Create your rider profile in seconds. No separate password — use your Google account to get started.',
  },
  {
    step: '2',
    title: 'Set up your group ride',
    body: 'Add meeting points, invite riders, and share a join link or QR code so everyone has the same plan.',
  },
  {
    step: '3',
    title: 'Ride together',
    body: 'Check in at stops, follow the captain, and complete the ride as one coordinated group.',
  },
] as const;

export function HowItWorksPage() {
  return (
    <PublicContentPage seo={seoForPath('/how-it-works')}>
      {publicPageHeading(
        'How to organize group motorcycle rides with RideMaadi',
        'From sign-in to finish line — a simple flow for planning, joining, and completing motorcycle group rides.',
      )}
      <section aria-labelledby="steps-heading">
        <h2 id="steps-heading" className="sr-only">
          Three steps to your next group ride
        </h2>
        <ol className="grid gap-4 sm:grid-cols-3">
          {STEPS.map(({ step, title, body }) => (
            <li
              key={step}
              className="rounded-2xl bg-surface p-5 shadow-sm shadow-black/[0.04] dark:shadow-black/20"
            >
              <span
                className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-primary text-sm font-bold text-primary-fg"
                aria-hidden
              >
                {step}
              </span>
              <h2 className="mt-3 text-base font-semibold">{title}</h2>
              <p className="mt-1.5 text-sm leading-relaxed text-muted">{body}</p>
            </li>
          ))}
        </ol>
      </section>
      <section className="mt-10 space-y-3" aria-labelledby="why-heading">
        <h2 id="why-heading" className="text-lg font-semibold">
          Why groups use RideMaadi
        </h2>
        <p className="text-sm leading-relaxed text-muted sm:text-base">
          Group motorcycle rides need a shared plan — not a chain of messages that half the group
          never sees. RideMaadi gives every rider the same meeting points, timing, and ride details
          in one motorcycle ride planning app.
        </p>
      </section>
      <div className="mt-12">
        <PublicCta />
      </div>
    </PublicContentPage>
  );
}
